import { getLocale } from "../runtime";

const sv_itemsnotreserved = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `* Produkterna är inte reserverade.`
};

const itemsnotreserved = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_itemsnotreserved(inputs)
	return "itemsNotReserved";
};

export { itemsnotreserved as "itemsNotReserved" };